import React, { useEffect, useState } from "react";
import Card from "../../../../../../../common/element/Card";
import BtnPrimary from "../../../../../../../common/element/Buttons/btnPrimary";
import Dialog from "../../../../../../../common/element/Dialog";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useDispatch, useSelector } from "react-redux";
import BtnLight from "../../../../../../../common/element/Buttons/btnLight";
import { InviteWorker } from "../../../../../../../actions/provider-portal/worker/InviteWorker";
import useUnauthorizedHandler from "../../../../../../../common/snippet/useUnauthorizedHandler";
import { GetInvoicePdfById } from "../../../../../../../actions/admin-provider/clients/GetInvoicePdfById";
import ThreeDotLoader from "../../../../../../../common/element/ButtonLoader/ThreeDotLoader";
import { UpdateProviderPaymentResponsibility } from "../../../../../../../actions/admin-provider/clients/UpdateProviderPaymentResponsibility";
import { GetSignedUrlByKey } from "../../../../../../../actions/public/GetSignedUrlByKey";

const PaymentMethod = ({
  provider_type_id,
  onDialogClose,
  openUnsaveDialog,
  updateObject,
  isProvLicencePaid,
  personName,
  paymentInfo,
  abn_nzbn,
  client_trading_name,
}) => {
  const handleUnauthorizedAccess = useUnauthorizedHandler();
  const [dialogInvoice, setDialogInvoice] = useState(false);
  const dispatch = useDispatch();
  const ipAddress = useSelector((state) => state?.ipAddress?.ip);
  const stripe = useStripe();
  const elements = useElements();
  const [dialogIsOpen, setIsOpen] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const [error, setError] = useState(null);
  const [agree, setAgree] = useState(false);
  const [saveCard, setSaveCard] = useState(false);
  const [savedCard, setSavedCard] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [useSavedCard, setUseSavedCard] = useState(false); // Default to saved card
  const [workerFees, setWorkerFees] = useState("");
  const loginUserData = JSON.parse(localStorage.getItem("LoginUserData"));
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsProcessing(true);
    if (!useSavedCard) {
      if (!stripe || !elements) {
        return;
      }
      const cardElement = elements.getElement(CardElement);
      const { error, token } = await stripe.createToken(cardElement);

      if (error) {
        setIsProcessing(false);
        setError(error.message);
        console.error(error);
      } else {
        const payload = {
          ...updateObject,
          // ...paymentInfo,
          payment_info: JSON.stringify({
            amount: paymentInfo?.amount,
            stripe_price_object_id: paymentInfo?.stripe_price_object_id,
            cardToken: token.id,
            saveCard: saveCard,
          }),
          provider_type_fee: paymentInfo?.provider_type_fee,
          is_licence_paid_by_provider: isProvLicencePaid,
          client_abn_nzbn: abn_nzbn,
          client_trading_name: client_trading_name,
          billing_cycle_end_date: paymentInfo?.end_date,

        };

        dispatch(UpdateProviderPaymentResponsibility(payload,ipAddress))
          .then((response) => {
            if (response.success) {
              setDialogInvoice(true);
              if (updateObject?.newPayResponsible == "client_pays") {
                // setIsProcessing(false);
                if (response?.xeroInvoice?.xero_invoice_pdf) {
                  dispatch(
                    GetSignedUrlByKey(
                      { url: response?.xeroInvoice?.xero_invoice_pdf },
                      "admin/provider"
                    )
                  ).then((InnerResponse) => {
                    if (InnerResponse.success) {
                      setIsProcessing(false);
                      setInvoiceData({
                        xero_invoice_number:
                          response?.xeroInvoice?.xero_invoice_number,
                        xero_invoice_pdf: InnerResponse?.data,
                      }).finally(()=>{
                        setIsProcessing(false);
                      })
                    }
                  });
                }
              } else {
                dispatch(
                  GetInvoicePdfById({
                    sub_invoice_id: response?.data?.sub_invoice_id,
                  })
                ).then((responsedata) => {
                  if (responsedata.success) {
                    setIsProcessing(false);
                    setInvoiceData(responsedata?.data);
                    setDialogInvoice(true);
                  } else {
                    setIsProcessing(false);
                  }
                }).finally(()=>{
                  setIsProcessing(false);
                })
              }

              // localStorage.setItem("workerInviteData", "");
              // setAddOpen(true);
              // setIsOpen(false);
              // setinviteData([]);
              // setrefetch(!refetch);
            }

            if (response.status == 409) {
              // notify.show(response.message, "error");
              setIsProcessing(false);
            } else if (response.status === 401) {
              setIsProcessing(false);
              handleUnauthorizedAccess();
            }
          })
          .catch((error) => {
            setIsProcessing(false);
          });
      }
    } else {
      const payload = {
        ...updateObject,
        // ...paymentInfo,
        payment_info: JSON.stringify({
          amount: paymentInfo?.amount,
          stripe_price_object_id: paymentInfo?.stripe_price_object_id,
        }),
        provider_type_fee: paymentInfo?.provider_type_fee,
        is_licence_paid_by_provider: isProvLicencePaid,
        client_abn_nzbn: abn_nzbn,
        client_trading_name: client_trading_name,
        billing_cycle_end_date: paymentInfo?.end_date, // 
        // stripe_price_object_id: paymentInfo?.stripe_price_object_id,
      };

      dispatch(UpdateProviderPaymentResponsibility(payload,ipAddress))
        .then((response) => {
          if (response.success) {
            dispatch(
              GetInvoicePdfById({
                sub_invoice_id: response?.data?.sub_invoice_id,
              })
            ).then((responsedata) => {
              if (responsedata.success) {
                setIsProcessing(false);
                setInvoiceData(responsedata?.data);
                setDialogInvoice(true);
              } else {
                setIsProcessing(false);
              }
            }).finally(()=>{
              setIsProcessing(false);
            })

            // localStorage.setItem("workerInviteData", "");
            // setAddOpen(true);
            // setIsOpen(false);
            // setinviteData([]);
            // setrefetch(!refetch);
          }

          if (response.status == 409) {
            // notify.show(response.message, "error");
            setIsProcessing(false);
          } else if (response.status === 401) {
            setIsProcessing(false);
            handleUnauthorizedAccess();
          }
        })
        .catch((error) => {
          setIsProcessing(false);
        });
    }
  };

  const onCloseInvoice = () => {
    onDialogClose();
    setDialogInvoice(false);
    openUnsaveDialog();
  };
  const downloadInvoice = () => {
    // invoiceData.xero_invoice_pdf
    if (invoiceData && invoiceData.xero_invoice_pdf) {
      const link = document.createElement("a");
      link.href = invoiceData.xero_invoice_pdf;
      link.download = "invoice.pdf"; // Set the file name
      link.target = "_blank"; // Open in new tab for security if on another domain
      link.click();
    } else {
      console.error("No PDF URL found in invoice data");
    }
  };

  const closePayment = (e) => {
    e.preventDefault();
    onDialogClose();
    openUnsaveDialog();
  };

  useEffect(() => {
    if (paymentInfo?.provider_type_fee == "assignment") {
      setUseSavedCard(true);
      setSavedCard(paymentInfo?.cardDetails[0]);
    }
    if(paymentInfo?.provider_type_fee == "licence" && paymentInfo?.subscription_id){
      setUseSavedCard(true);
      setSavedCard(paymentInfo?.cardDetails[0]);
      // stop if card details not there
    }
  }, [paymentInfo?.provider_type_fee == "assignment" , paymentInfo?.provider_type_fee == "licence"]);

  return (
    <div>
      <h5 className="text-blue-800 font-semibold text-2xl mb-2 mt-3">
        Payment
      </h5>
      <p className="text-gray-700 mb-3">
      This annual payment covers a license for one client and two included workers
      </p>
      <div>
        <div className="w-full">
          <form>
            <Card className="p-7 border border-gray-200 rounded-xl">
              <h4 className="font-bold text-gray-700 text-base mb-1">
                Annual Fee (ex GST)
              </h4>
              <p className="text-gray-700">$ {paymentInfo?.amount}</p>
            </Card>
            <div>
              <div className="w-full">
                <form>
                  
                  <Card className="p-7 border border-gray-200 rounded-xl mt-7">
                    <h5 className="text-blue-800 font-semibold text-2xl mb-2">
                      Payment options
                    </h5>
                    <div className="bg-gray-100 rounded-lg">
                      <div className="bg-white w-full p-4 rounded-lg">
                        <div className="flex items-center justify-between mb-3">
                          <h2 className="text-lg font-semibold">Card Information</h2>
                          <span className="text-gray-500 text-sm font-normal flex items-center gap-2">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33334 8 1.33334C4.3181 1.33334 1.33334 4.3181 1.33334 8C1.33334 11.6819 4.3181 14.6667 8 14.6667Z" stroke="#6B7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                              <path d="M8 10.6667V8" stroke="#6B7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                              <path d="M8 5.33334H8.00667" stroke="#6B7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            Please go to settings to change card details.
                          </span>
                        </div>

                        {/* Saved Card Option */}
                        {useSavedCard && (
                          <div
                            className="flex items-center gap-3 p-3 border rounded-lg cursor-pointer"
                            onClick={() => setUseSavedCard(true)}
                          >
                            <input
                              type="radio"
                              name="paymentMethod"
                              checked={useSavedCard}
                              onChange={() => setUseSavedCard(true)}
                              className="cursor-pointer"
                            />
                            <span className="text-sm text-gray-700">
                              Use saved card ({savedCard?.brand} ****{" "}
                              {savedCard?.last4}, exp {savedCard?.exp_month}/
                              {savedCard?.exp_year})
                            </span>
                          </div>
                        )}

                        {/* New Card Option */}
                        {/* <div
                          className="flex items-center gap-3 p-3 border rounded-lg mt-3 cursor-pointer"
                          onClick={() => setUseSavedCard(false)}
                        >
                          <input
                            type="radio"
                            name="paymentMethod"
                            checked={!useSavedCard}
                            onChange={() => setUseSavedCard(false)}
                            className="cursor-pointer"
                          />
                          <span className="text-sm text-gray-700">
                            Use a different card
                          </span>
                        </div> */}

                        {/* Card Input - Show only if entering new card */}
                        {!useSavedCard && (
                          <div className="border rounded-lg p-3 mt-4 focus-within:border-blue-500 transition">
                            <CardElement
                              options={{
                                hidePostalCode: true,
                                style: {
                                  base: {
                                    fontSize: "16px",
                                    color: "#333",
                                    "::placeholder": { color: "#a0aec0" },
                                  },
                                  invalid: { color: "#e53e3e" },
                                },
                              }}
                            />
                          </div>
                        )}

                        {/* Checkbox */}
                        <div className="flex items-center gap-2 mt-4">
                          <input
                            type="checkbox"
                            id="terms"
                            checked={agree}
                            onChange={() => setAgree(!agree)}
                            className="cursor-pointer"
                          />
                          <label
                            htmlFor="terms"
                            className="text-sm text-gray-600 cursor-pointer"
                          >
                            I understand and accept that this licensing fee is valid for 12 months
                          </label>
                        </div>

                        

                        {/* Save card checkbox: only when entering a new card */}
                        {!useSavedCard && (
                          <div className="flex items-start gap-2 mt-2">
                            <input
                              type="checkbox"
                              id="saveCard"
                              checked={saveCard}
                              onChange={() => setSaveCard(!saveCard)}
                              className="mt-1 cursor-pointer"
                            />
                            <label htmlFor="saveCard" className="text-sm text-gray-600 cursor-pointer">
                              Save card for future payments
                            </label>
                          </div>
                        )}

                        {/* Error Message */}
                        {error && (
                          <p className="text-red-500 text-sm">{error}</p>
                        )}

                        {/* Submit Button */}
                        <div className="flex dailog-footer gap-4 ">
                          <BtnLight
                           className="mr-1.5"
                            onClick={closePayment}
                          >
                            <img
                              src="assets/icons-svg/arrow-left.svg"
                              alt=""
                              className="mr-2"
                            />
                            Cancel
                          </BtnLight>
                          <BtnPrimary
                            disabled={
                               !agree ||
                               isProcessing}
                            className=""
                            onClick={handleSubmit}
                          >
                            {isProcessing ? (
                              <ThreeDotLoader />
                            ) : (
                              "Confirm and Pay"
                            )}
                          </BtnPrimary>
                        </div>
                      </div>
                    </div>
                  </Card>
                </form>
              </div>
            </div>
          </form>
        </div>
        {/* Invoice code */}
        <Dialog
          isOpen={dialogInvoice}
          onClose={onCloseInvoice}
          onRequestClose={onCloseInvoice}
          bodyOpenClassName="overflow-hidden"
          width={720}
        >
          <div className="flex border-b mb-5 pb-5 px-6 pt-6 items-center">
            <span className="h-12 w-12 border rounded-lg border-gray-200 flex items-center justify-center shadow-sm mr-4">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_12450_78578)">
                  <path
                    d="M19.1658 20.8745C19.9709 20.8745 20.6214 20.2225 20.6214 19.4191V15.5467C20.6214 14.7434 19.9709 14.0914 19.1658 14.0914H13.3557C12.5506 14.0914 11.9 14.7434 11.9 15.5467V19.4191C11.9 20.2225 12.5506 20.8745 13.3557 20.8745H19.1658ZM19.1658 19.5128H13.3557C13.304 19.5128 13.262 19.4707 13.262 19.4191V15.5467C13.262 15.4951 13.304 15.4531 13.3557 15.4531H19.1658C19.2174 15.4531 19.2594 15.4951 19.2594 15.5467V19.4191C19.2594 19.4707 19.2174 19.5128 19.1658 19.5128Z"
                    fill="#0E4E9A"
                    stroke="#0E4E9A"
                    stroke-width="0.2"
                  />
                  <path
                    d="M19.2593 15.5458C19.2593 16.0251 18.8703 16.4141 18.391 16.4141H14.1303C13.651 16.4141 13.262 16.0251 13.262 15.5458C13.262 15.1699 12.9569 14.8648 12.581 14.8648C12.2051 14.8648 11.9 15.1699 11.9 15.5458C11.9 16.7769 12.8992 17.7761 14.1303 17.7761H18.391C19.6221 17.7761 20.6213 16.7769 20.6213 15.5458C20.6213 15.1699 20.3162 14.8648 19.9403 14.8648C19.5644 14.8648 19.2593 15.1699 19.2593 15.5458Z"
                    fill="#0E4E9A"
                    stroke="#0E4E9A"
                    stroke-width="0.2"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M17.81 14.889C18.1307 14.889 18.391 14.6287 18.391 14.308V13.5333C18.391 12.785 17.7852 12.1777 17.0354 12.1777H15.486C14.7362 12.1777 14.1304 12.785 14.1304 13.5333V14.308C14.1304 14.6287 14.3907 14.889 14.7114 14.889H17.81ZM17.229 13.8727H15.2924V13.5333C15.2924 13.4265 15.3792 13.3397 15.486 13.3397H17.0354C17.1422 13.3397 17.229 13.4265 17.229 13.5333V13.8727Z"
                    fill="#0E4E9A"
                    stroke="#0E4E9A"
                    stroke-width="0.2"
                  />
                  <path
                    d="M10.78 14.0664C8.90316 14.098 5.33487 14.7346 3.56036 18.5573C3.34841 19.0142 3.38479 19.737 4.73027 19.776C6.07575 19.815 8.606 19.7923 10.166 19.776"
                    stroke="#0E4E9A"
                    stroke-width="1.95"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <circle
                    cx="11.5698"
                    cy="7.90674"
                    r="3.75986"
                    stroke="#0E4E9A"
                    stroke-width="1.95"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_12450_78578">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <div>
              <h5 className="mb-0 text-gray-900 text-base font-semibold">
                Connect with {personName?.map((item) => item?.label).join(",")}
              </h5>
              <p>
                Ensure a successful connection with the client by completing
                these steps
              </p>
            </div>
          </div>
          <div className="pl-4 pr-4">
            <div className="mb-5 bg-gray-50 rounded-xl border border-gray-200 p-5 rounded-xl ">
              <h3 className="mb-1 text-gray-700 font-bold text-base">
                Payment successful and invites sent to Workers!
              </h3>
              <p className="mb-4 text-gray-700">
                Thank you for your payment. A confirmation of this transaction
                has been sent to your email.
              </p>
              <h3 className="mb-1 text-gray-700 font-bold text-base">
                Invoice number{" "}
              </h3>
              <p className="mb-4 text-gray-700">
                <p>{invoiceData?.xero_invoice_number}</p>
              </p>
              <button
                className="flex gap-1  text-blue-700 hover:text-blue-900 focus:text-blue-700"
                onClick={downloadInvoice}
              >
                Download invoice{" "}
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.583 13.2866V14.2866C17.583 15.6868 17.583 16.3868 17.3105 16.9216C17.0708 17.392 16.6884 17.7745 16.218 18.0141C15.6832 18.2866 14.9831 18.2866 13.583 18.2866H6.58301C5.18288 18.2866 4.48281 18.2866 3.94803 18.0141C3.47763 17.7745 3.09517 17.392 2.85549 16.9216C2.58301 16.3868 2.58301 15.6868 2.58301 14.2866V13.2866M14.2497 9.11995L10.083 13.2866M10.083 13.2866L5.91634 9.11995M10.083 13.2866V3.28662"
                    stroke="#5786CC"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>

          <div className="flex dailog-footer ">
            <BtnPrimary
              onClick={() => onCloseInvoice()}
              className="ml-1.5 w-auto	px-4 my-auto	ml-auto	mr-0"
            >
              Okay
            </BtnPrimary>
          </div>
        </Dialog>
      </div>
    </div>
  );
};

export default PaymentMethod;
